export interface Hub {
  subscribe(topic: string, listener: () => void): () => void;
  touch(topic: string): void;
}

export function createHub(schedule: (flush: () => void) => void): Hub {
  const listeners = new Map<string, Set<() => void>>();
  let pending = new Set<string>();
  const flush = () => {
    const topics = pending;
    pending = new Set();
    const called = new Set<() => void>();
    for (const topic of topics) {
      for (const listener of listeners.get(topic) ?? []) {
        if (called.has(listener)) continue;
        called.add(listener);
        listener();
      }
    }
  };
  return {
    subscribe(topic, listener) {
      const set = listeners.get(topic) ?? new Set();
      set.add(listener);
      listeners.set(topic, set);
      return () => {
        set.delete(listener);
        if (set.size === 0) listeners.delete(topic);
      };
    },
    touch(topic) {
      if (pending.has(topic)) return;
      if (pending.add(topic).size === 1) schedule(flush);
    },
  };
}
